export const NavigationGroups = {
  dashboard: 'dashboard',
  production: 'production',
  traceability: 'traceability',
  sales: 'sales',
  workersAndCompetencies: 'workersAndCompetencies',
  catalog: 'catalog',
  warehouse: 'warehouse',
  users: 'users',
  synchronizations: 'synchronizations',
  products: 'products',
  orders: 'orders',
  offers: 'offers',
  contractors: 'contractors',
  workers: 'workers',
  technologySchemas: 'technologySchemas',
} as const;
